import React, {useEffect, useState} from 'react';
import ProductFilters from "../../../pod/components/product/product-filters";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchThemes} from "../../../theme/services/theme-data-service";
import _ from "lodash";
import {getSingleDesign, prepareDesignData, searchDesigns} from "../../services/design-data-service";
import Promise from "bluebird";
import {getSingleDesignVariant} from "../../services/design-variant-data-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowDesignStatistics from "../common/show-design-statistics";


const CopyDesigns = ({currentTheme, currentPod, copyDesignList}) => {
    const [showModal, setShowModal] = useState(false);
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [podList, setPodList] = useState(null);
    const [selectedPod, setSelectedPod] = useState(currentPod);
    const [selectedTheme, setSelectedTheme] = useState(currentTheme);
    const [themeList, setThemeList] = useState(null);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [bulkUpdate, setBulkUpdate] = useState(true);
    const [excludeTemplate, setExcludeTemplate] = useState(true);
    const [designList, setDesignList] = useState([]);
    const [designDetailList, setDesignDetailList] = useState([]);
    const [selectedDesigns, setSelectedDesigns] = useState([]);

    const handleConfirmAction = async () => {
        setDataFetchInProgress(true)
        const selectedDesignList = [];
        const existingSelectedDesigns = [...selectedDesigns];

        await Promise.mapSeries(existingSelectedDesigns, async designId => {
            const designDetailDoc = await getSingleDesign(designId);
            const designDetailData = prepareDesignData(designDetailDoc)
            selectedDesignList.push(_.cloneDeep(designDetailData));
        });

        copyDesignList(selectedDesignList, excludeTemplate);
        setDataFetchInProgress(false)
        setShowModal(false);
    }

    const handleCancelAction = () => {
        setShowModal(false);
    }

    useEffect(() => {
        if (showModal) {
            // setFilterCriteria({});
            initFilters();
            getAllPodList();
            getAllThemeList();
            handleSearchDesigns();
        }
    }, [showModal]);

    useEffect(() => {
        if (currentTheme) {
            setSelectedTheme(currentTheme);
        }
    }, [currentTheme]);

    const initFilters = () => {
        const tempFilters: any = {};
        const existingPod = {...selectedPod};
        const existingTheme = {...selectedTheme};

        if (existingPod) {
            tempFilters.podId = existingPod.id;
        }

        if (existingTheme) {
            tempFilters.themeId = existingTheme.id;
        }

        setFilterCriteria(tempFilters);
    }

    const getAllPodList = async () => {
        const podListResult = await searchPods('');
        setPodList(podListResult);
    }

    const getAllThemeList = async () => {
        const themeListResult = await searchThemes('');
        setThemeList(_.orderBy(themeListResult, ['startText']));
    }

    const handleSearchDesigns = async () => {
        const searchCriteriaList = [];
        if (selectedPod) {
            searchCriteriaList.push({field: 'podId', condition: '==', value: selectedPod?.id});
        }

        _.forIn(filterCriteria, (value, field) => {
            if (!_.isEmpty(value)) {
                searchCriteriaList.push({field: field, condition: '==', value: value});
            }
        });

        const designsListResult = await searchDesigns(searchCriteriaList);
        setDesignList(designsListResult);
        setDataFetchInProgress(false);
    }

    const handleDetailChanges = (event) => {
        const {name, value} = event.target;
        filterCriteria[name] = value;
        setFilterCriteria(filterCriteria);

        if (name === 'podId') {
            const existingPodList = [...podList];
            const podsMap = _.keyBy(existingPodList, 'id');
            setSelectedPod(podsMap[value]);
        } else if (name === 'themeId') {
            handleSearchDesigns();
        }
    }

    const addOrRemoveDesign = (design) => {
        let existingSelectedDesigns = [...selectedDesigns];
        const existingIndex = _.indexOf(existingSelectedDesigns, design.id);

        if (existingIndex === -1) {
            existingSelectedDesigns.push(design.id);
        } else {
            delete existingSelectedDesigns[existingIndex];
            existingSelectedDesigns = _.compact(existingSelectedDesigns);
        }

        setSelectedDesigns(existingSelectedDesigns);
    }

    const selectAllDesigns = () => {
        let existingDesignList = [...designList];
        const designs = _.map(existingDesignList, 'id');
        setSelectedDesigns(designs);
    }

    const clearAllDesigns = () => {
        setSelectedDesigns([]);
    }

    const handleBulkUpdateSettingsChanges = (event, background, design) => {
        const {name, value, type} = event.target;
        const existingDesignDetail = {...design};
        const existingDesignDetailList = [...designDetailList];
        const itemIndex = _.findIndex(existingDesignDetailList, ['id', existingDesignDetail.id]);

        if (type === 'checkbox') {
            existingDesignDetailList[itemIndex].settings[name] = !existingDesignDetailList[itemIndex][name];
        } else {
            existingDesignDetailList[itemIndex].settings[name] = value;
        }

        setDesignDetailList(existingDesignDetailList);
    }

    return (
        <>
            <div className="flex items-center justify-center">
                <button
                    className="button-green-outline py-2 px-4"
                    onClick={() => {
                        clearAllDesigns();
                        setShowModal(true);
                    }}>
                    <span>Copy Designs</span>
                </button>
            </div>
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-4/5 my-6">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-between items-center px-5 pt-6 rounded-t">
                                    <h3 className="text-3xl font-bold">Copy Designs</h3>

                                    {/*<div className="">
                                        <ShowDesignDetail designDetail={currentDesignDetail}/>
                                    </div>*/}

                                    <div className="flex justify-center items-center">
                                        {/*<div className="field-container">
                                            <div className="justify-start flex">
                                                <input
                                                    type="checkbox"
                                                    className="h-6 w-6 mr-1"
                                                    id="bulkUpdate"
                                                    name="bulkUpdate"
                                                    checked={bulkUpdate}
                                                    onChange={() => {
                                                        setBulkUpdate(!bulkUpdate);
                                                    }}>
                                                </input>
                                                <div className=''>
                                                    <label className='field-label self-center ml-1'
                                                           htmlFor='bulkUpdate'>Bulk Update</label>
                                                </div>
                                            </div>
                                        </div>*/}

                                        <div className="field-container">
                                            <div className="justify-start flex">
                                                <input
                                                    type="checkbox"
                                                    className="h-6 w-6 mr-1"
                                                    id="excludeTemplate"
                                                    name="excludeTemplate"
                                                    checked={excludeTemplate}
                                                    onChange={() => {
                                                        setExcludeTemplate(!excludeTemplate);
                                                    }}>
                                                </input>
                                                <div className=''>
                                                    <label className='field-label self-center ml-1'
                                                           htmlFor='excludeTemplate'>Exclude Template</label>
                                                </div>
                                            </div>
                                        </div>

                                        <button onClick={selectAllDesigns}
                                                className="button-green px-4 h-10">
                                            Select All
                                        </button>

                                        <button onClick={clearAllDesigns}
                                                className="button-gray px-4 h-10 ml-2">
                                            Clear All
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative p-6">

                                    <div className="flex justify-between -mt-4 -ml-2">

                                        <div className="flex justify-start">
                                            <div className="field-container">
                                                <div className="field-label">
                                                    Theme
                                                </div>
                                                <select
                                                    className="input-field"
                                                    id="themeId"
                                                    name="themeId"
                                                    value={filterCriteria?.themeId}
                                                    onChange={handleDetailChanges}>
                                                    <option value="">Choose Theme</option>
                                                    {themeList?.map((theme, index) => (
                                                        <option key={index}
                                                                value={theme?.id}>{theme?.startText}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="field-container">
                                                <div className="field-label">
                                                    POD <span
                                                    className="text-gray-400">({podList?.length})</span>
                                                </div>
                                                <select
                                                    className="input-field"
                                                    id="podId"
                                                    name="podId"
                                                    value={filterCriteria?.podId}
                                                    onChange={handleDetailChanges}>
                                                    <option value="">Choose POD</option>
                                                    {podList?.map((pod, index) => (
                                                        <option key={index}
                                                                value={pod?.id}>{pod?.displayLabel}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {selectedPod &&
                                                <div className="">
                                                    <ProductFilters
                                                        searchProductsList={handleSearchDesigns}
                                                        filterCriteria={filterCriteria}
                                                        setFilterCriteria={setFilterCriteria}
                                                        clearFilterCriteria={undefined}
                                                        podDetail={selectedPod}
                                                        hideColorsAndSizes={true}/>
                                                </div>
                                            }
                                        </div>

                                    </div>

                                    <div className="flex justify-center pt-2">

                                        <div
                                            className="flex flex-wrap w-full justify-start content-start copy-design-variant-section-container overflow-y-scroll border border-purple-600 rounded bg-gray-200 py-3 px-2">

                                            {designList?.map((design, index) => (
                                                <div key={index}
                                                     onClick={() => {
                                                         addOrRemoveDesign(design);
                                                     }}
                                                     className={'w-1/4 pb-2'}>
                                                    <div
                                                        className={`flex justify-between mx-1 cursor-pointer rounded border h-full
                                                        ${selectedDesigns.indexOf(design?.id) !== -1 ? 'bg-purple-100 text-purple-700 shadow-xl border-4 border-purple-600' : 'bg-white'}`}>

                                                        <div className="p-6 w-full">
                                                            <div className="h-24 -mt-2">
                                                                <div className="text-lg">{design?.quoteName}</div>
                                                                <div className="text-sm">{design?.themeName}</div>
                                                                <div className="font-bold">{design?.parent}
                                                                    {design?.size &&
                                                                        <span className=""> | {design?.size}</span>
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="flex justify-between">
                                                                <div className="mt-1">
                                                                    <div
                                                                        className="font-bold text-purple-700">{design?.podName}</div>
                                                                    <div
                                                                        className="text-sm">{design?.category}</div>
                                                                </div>

                                                                <ShowDesignStatistics designDetail={design}/>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            ))}

                                        </div>

                                        {/*{bulkUpdate &&
                                            <div
                                                className="ml-4 flex flex-wrap w-full justify-start content-start copy-design-variant-section-container overflow-y-scroll border border-purple-600 rounded bg-white py-3 px-2">

                                                {designDetailList?.map((design, index) => (
                                                    <React.Fragment key={`design-variant-${index}`}>
                                                        {selectedDesigns?.indexOf(design?.id) !== -1 &&

                                                            <div className={'w-full pb-2'}>
                                                                <div
                                                                    className={`flex justify-between mx-1 rounded border h-full bg-gray-100`}>

                                                                    <div
                                                                        className="p-4 align-middle flex justify-between">
                                                                        <div className="flex justify-start">
                                                                            <div
                                                                                className="font-semibold mr-2">#{index + 1}</div>

                                                                            <div>
                                                                                <SelectColorTypeDetails
                                                                                    label={'Background Color & Shade'}
                                                                                    parentForm={design?.settings?.background}
                                                                                    colorAttribute={'background'}
                                                                                    colorKeyAttribute={'backgroundColorKey'}
                                                                                    colorCodeKeyAttribute={'backgroundColorCodeKey'}
                                                                                    settings={design?.settings}
                                                                                    handleColorDetailsChanges={(event, background) => {
                                                                                        handleBulkUpdateSettingsChanges(event, background, design);
                                                                                    }}
                                                                                    handleClearColorDetailsChanges={undefined}/>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        }
                                                    </React.Fragment>

                                                ))}

                                            </div>
                                        }*/}
                                    </div>

                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-center px-6 pb-6 rounded-b">
                                    <button
                                        className="button-gray px-3 py-2"
                                        onClick={handleCancelAction}>
                                        Cancel
                                    </button>

                                    {!dataFetchInProgress &&
                                        <button
                                            className="ml-2 button-green px-3 py-2"
                                            onClick={handleConfirmAction}>
                                            Confirm Selected Designs
                                        </button>
                                    }

                                    {dataFetchInProgress &&
                                        <button
                                            className="ml-2 button-gray px-3 py-2"
                                            disabled={true}
                                            onClick={() => {
                                            }}>
                                            Confirm Selected Designs
                                        </button>
                                    }

                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default CopyDesigns
